<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm"
                 :rules="dataRule"
                 ref="dataForm"
                 @keyup.enter.native="dataFormSubmit()"
                 label-width="132px"
                 style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <el-form-item label="字段名称" prop="itemName">
                <el-input v-model="dataForm.displayName" placeholder="字段名称" disabled></el-input>
            </el-form-item>
            <el-form-item label="字段编码" prop="itemCode">
                <el-input v-model="dataForm.itemCode" placeholder="字段编码"></el-input>
            </el-form-item>
            <el-form-item label="字段名称[数据库]" prop="columnName">
                <el-input v-model="dataForm.columnName" placeholder="字段名称[数据库]" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否为查重字段" prop="isUnionIndex">
                <el-select v-model="dataForm.isUnionIndex" placeholder="是否为查重字段"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否必填" prop="required">
                <el-select v-model="dataForm.required" placeholder="是否隐藏" disabled
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="默认值" prop="defaultValue">
              <el-input v-model="dataForm.defaultValue" placeholder="默认值"></el-input>
            </el-form-item>
            <el-form-item label="验证规则类型" prop="validType">
                <el-select v-model="dataForm.validType" placeholder="验证规则类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="(item) in validTypeList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据类型" prop="dataType">
                <el-select v-model="dataForm.dataType" placeholder="数据类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="(key, index) in dataTypeList"
                            :key="index"
                            :label="key.value"
                            :value="key.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="匹配字符串长度类型" prop="jsonContentType" v-if="dataForm.validType==1">
                <el-select v-model="dataForm.jsonContentType" @change="handleChooseTool" @clear="clearSelect('jsonContentType')" clearable placeholder="类型选择"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in jsonContentTypeList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="匹配字符串长度" prop="jsonContent" v-if="dataForm.validType==1" :error="jsonContentError">
<!--                <el-input v-if="dataForm.jsonContentType == 4" v-model="dataForm.jsonContent" placeholder="区间类型以,隔开如：1,5"></el-input>-->
                <el-input-number v-model="dataForm.jsonContent" class="elInputNumber" :style="{'width':dataForm.jsonContentType == 4?'calc(50% - 8px)':'100%'}" :controls="false" :min="1" placeholder="请输入数字"></el-input-number>
                <span v-if="dataForm.jsonContentType == 4"> - </span>
                <el-input-number v-if="dataForm.jsonContentType == 4" v-model="dataForm.jsonContentMax" class="elInputNumber" style="width:calc(50% - 8px)" :controls="false" :min="1" placeholder="请输入数字"></el-input-number>
            </el-form-item>
            <el-form-item label="匹配表达式" prop="patternRegex" v-if="dataForm.validType==99">
                <el-input v-model="dataForm.patternRegex" placeholder="匹配表达式"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
            </el-form-item>
          <el-form-item label="依赖项校验" prop="linkTable">
            <el-input v-model="dataForm.linkTable" placeholder="依赖项校验"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    tableId: '',
                    appId: '',
                    itemCode: '',
                    itemName: '',
                    columnName: '',
                    isUnionIndex: '',
                    hidden: false,
                    defaultValue: '',
                    jsonContent: '',
                    jsonContentMax:null,
                    jsonContentType:null,
                    showInList: false,
                    patternRegex: '',
                    dataType: '',
                    validType: '',
                    canEdit: true,
                    single: false,
                    required: false,
                    sort: 10,
                    displayName: '',
                    valueDesc: '',
                    dataFormat: '',
                    dataStatus: '',
                    linkTable: ''
                },
                errorData:{},
                validTypeList: [{'id':'0','value':'富文本无需校验'},{'id':'1','value':'长度校验'},{'id':'2','value':'字典校验'},{'id':'99','value':'正则校验'}],
                dataTypeList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                jsonContentTypeList: [{'text': '定值', 'value': '1'},{'text': '最大', 'value': "2"}, {'text': '最小', 'value': "3"}, {'text': '区间', 'value': "4"}],
                jsonContentTypeMap:{},
                dataRule: {
                    displayName: [
                        {required: true, message: '字段名称不能为空', trigger: 'blur'}
                    ],
                    itemCode: [
                        {required: true, message: '字段编码不能为空', trigger: 'blur'}
                    ],
                    columnName: [
                        {required: true, message: '字段名称[数据库]不能为空', trigger: 'blur'}
                    ],
                    dataType: [
                        {required: true, message: '字段类型不能为空', trigger: 'blur'}
                    ],
                    validType: [
                        {required: true, message: '验证类型不能为空', trigger: 'blur'}
                    ],
                    jsonContentType: [
                        {required: true, message: '匹配字符串长度类型不能为空', trigger: ['change','blur']}
                    ],
                    jsonContent: [
                        {required: true, message: '匹配字符串长度不能为空', trigger: 'blur'}
                    ],
                    patternRegex: [
                        {required: true, message: '匹配表达式不能为空', trigger: 'blur'}
                    ],
                }
            }
        },
        computed: {
            jsonContentError: function () {
                return this.errorData.jsonContent;
            },
        },
        methods: {
            getHttpReq(url, method = 'post', extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL: '',
                }
                ops = Object.assign(ops, extOps)
                return this.$http(ops)
            },
            clearSelect(prop){
                this.$forceUpdate()
                this.dataForm[prop] = null;

            },
            handleChooseTool(e) {
                this.$forceUpdate()
                this.dataForm.jsonContentType = e
            },
            init(id, ruleId, columnName) {
                this.dataForm.id = id || ''
                this.dataForm.tableId = ruleId || ''
                this.dataForm.columnName = columnName || ''
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                })
                let _self = this
                axios.all([
                    this.getHttpReq(this.$http.adornUrl('/customform/columnmeta/listDataType'), 'get')
                ])
                    .then(axios.spread(function (dataTypeResult) {
                        _self.dataTypeList = dataTypeResult.data.data
                        _self.loadItemInfo(columnName)
                    }))
                this.getSelectData();
            },
            loadItemInfo(columnName) {
         //       if (this.dataForm.id) {
                    this.$http({
                        url: this.$http.adornUrl(`/customform/columnmeta/getByColumn?tableId=${this.dataForm.tableId}&columnName=${columnName}&id=${this.dataForm.id}`),
                        method: 'get',
                        baseURL: '',
                    }).then(({data}) => {
                        if (data) {
                            this.dataForm = data.data;
                            if (this.dataForm.dataType != undefined) {
                                this.dataForm.dataType = this.dataForm.dataType + ''
                            }
                            if (this.dataForm.validType != undefined) {
                                this.dataForm.validType = this.dataForm.validType + ''
                            }
                            if(data.data.jsonContent){
                                let JSONObj  = JSON.parse(data.data.jsonContent);
                                if(JSONObj.length != undefined){
                                    this.dataForm.jsonContentType = '1';
                                    this.dataForm.jsonContent = JSONObj.length;
                                    return
                                }
                                if(JSONObj.maxLength != undefined && JSONObj.minLength != undefined){
                                    this.dataForm.jsonContentType = '4';
                                    this.dataForm.jsonContent = JSONObj.minLength;
                                    this.dataForm.jsonContentMax = JSONObj.maxLength;
                                    return
                                }
                                if(JSONObj.maxLength != undefined){
                                    this.dataForm.jsonContentType = '2';
                                    this.dataForm.jsonContent = JSONObj.maxLength;
                                    return
                                }
                                if(JSONObj.minLength != undefined){
                                    this.dataForm.jsonContentType = '3';
                                    this.dataForm.jsonContent = JSONObj.minLength;
                                    return
                                }
                            }
                        }
                    })
                //     }
            },
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let jsonContent = {};
                        if(this.dataForm.jsonContentType && this.jsonContentTypeMap[this.dataForm.jsonContentType]){
                            let jsonContentType = this.jsonContentTypeMap[this.dataForm.jsonContentType];
                            console.log(this.dataForm.jsonContent,this.dataForm.jsonContentMax)
                            if(jsonContentType.prefix.indexOf(',') > -1){
                                if(this.dataForm.jsonContent == undefined || this.dataForm.jsonContentMax == undefined ||  this.dataForm.jsonContent >= this.dataForm.jsonContentMax){
                                    this.errorData = {
                                        jsonContent:"区间值数字填写不正确，后者不得小于前者。"
                                    }
                                    return
                                }
                                let arr = jsonContentType.prefix.split(',');
                                jsonContent[arr[0]] = this.dataForm.jsonContent;
                                jsonContent[arr[1]] = this.dataForm.jsonContentMax;

                            }else{
                                jsonContent[jsonContentType.prefix] = this.dataForm.jsonContent;
                            }
                        }

                        let dataForm = JSON.parse(JSON.stringify(this.dataForm));
                        dataForm.jsonContent = JSON.stringify(jsonContent) != "{}"?JSON.stringify(jsonContent):'';
                        this.$http({
                            url: this.$http.adornUrl('/customform/columnmeta/save'),
                            method: 'post',
                            baseURL: '',
                            data: dataForm
                        }).then(({data}) => {
                            if (data && data.code === '1') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            },
            getSelectData(){//获取下拉框数据
                this.$http({//验证规则类型
                    url: this.$http.adornUrl('/customform/columnmeta/validtype'),
                    method: 'get',
                    baseURL:""
                }).then(({data}) => {
                    if(data.code==1){
                        this.validTypeList=data.data;
                    }else{
                        this.$message.error(data.msg)
                    }

                })

                this.$http({//验证规则子项类型
                    url: this.$http.adornUrl('/customform/columnmeta/validitemtype'),
                    method: 'get',
                    baseURL: '',
                }).then(({data}) => {
                    if(data.code==1){
                        this.jsonContentTypeList=data.data;
                        let jsonContentTypeMap = {};
                        this.jsonContentTypeList.forEach((item)=>{
                                jsonContentTypeMap[item.key] = item;
                        })
                        this.jsonContentTypeMap = jsonContentTypeMap;

                    }else{
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .el-form /deep/ .el-form-item {
        width: 50%;
    }

    .elInputNumber{
        /deep/ .el-input__inner{
            text-align: left;
        }

    }

    .el-dialog__wrapper /deep/ .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
